import fs from 'node:fs'
import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'
import { namespaceInstallableContent } from '@next-adapter/installable-runtime/namespace-installable-content.js'
import { readTemplate } from '@next-adapter/template-reader/read-template.js'

export function ensureIntegrationRuntimeSupport(
  cwd: string,
  config: ResolvedBetterstartConfig,
  definition: BetterstartIntegrationDefinition
): void {
  if (definition.capabilities?.storageProvider?.provider !== 'railway-bucket') return

  const routePath = path.resolve(cwd, config.paths.api, 'storage', '[key]', 'route.ts')
  if (fs.existsSync(routePath)) return

  fs.mkdirSync(path.dirname(routePath), { recursive: true })
  fs.writeFileSync(
    routePath,
    namespaceInstallableContent(config, readTemplate('api/storage-read-route.ts')),
    'utf-8'
  )
}
